<ng-container *hasPermission="['PARKING_AREA_READ','PARKING_AREA_ALL']">
  <div class="container-fluid">
    <div class="page-title">
      <h2>Parcheggio - <b>{{detail_title}}</b></h2>
    </div>
    <form [formGroup]="parkingForm" (ngSubmit)="onSave()">
      <div class="row gap-3 mb-3 ">
        <div class="col-3">
          <label for="code">Codice</label>
          <input id="code" formControlName="code" class="form-control" type="text">
        </div>
        <div class="col-3">
          <label for="name">Nome</label>
          <input id="name" formControlName="name" class="form-control" type="text">
        </div>
        <div class="col-lg-3 align-content-center">
          <div class="form-check form-switch">
            <input class="form-check-input" formControlName="active" type="checkbox" id="flexSwitchCheckDefault">
            <label class="form-check-label" for="flexSwitchCheckDefault">Abilitato</label>
          </div>
        </div>
        <div class="col-12">
          <app-parking-map (coordinatesChange)="onCoordinatesChange($event)"></app-parking-map>
        </div>
        <div class="col">
          <label for="description">Descrizione</label>
          <textarea id="description" formControlName="description" name="description" class="form-control"
            rows="3"></textarea>
        </div>
        <div class="card p-0">
          <div class="card-header">
            <div class="d-flex gap-2">
              <span> Dati periodo </span>
              <div class="cursor-pointer" (click)="addValidityRange()"
                *hasPermission="['PARKING_AREA_UPDATE','PARKING_AREA_ALL']">
                <i bTooltip title="Elimina" class="fa-solid fa-plus"></i>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-12">
              <div formArrayName="validityRange">
                <div *ngFor="let validity of validityRange.controls; let i = index" [formGroupName]="i" class="mb-3">
                  <div class="row g-2">
                    <div class="col-lg-1 d-flex align-items-center justify-content-center">
                      <div class="cursor-pointer" (click)="removeValidityRange(i)"
                        *hasPermission="['PARKING_AREA_DELETE','PARKING_AREA_ALL']">
                        <i bTooltip title="Elimina" class="fa-solid fa-trash"></i>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <label for="validityRangeType" class="form-label">Tipologia</label>
                      <select class="form-select ss-no-validation" aria-label="Tipologia intervallo"
                        id="validityRangeType" formControlName="validityRangeType">
                        <option [value]="'GENERIC'">Periodo generico</option>
                        <option [value]="'FIXED'">Periodo fisso</option>
                      </select>
                    </div>
                    <ng-container *ngIf="validity.get('validityRangeType')?.value == 'FIXED'">
                      <div class="col-lg-4">
                        <label for="startDate" class="form-label">Data inizio</label>
                        <input type="date" class="form-control" formControlName="startDate" name="startDate">
                      </div>
                      <div class="col-lg-4">
                        <label for="endDate" class="form-label">Data fine</label>
                        <input type="date" class="form-control" formControlName="endDate">
                      </div>
                    </ng-container>
                    <ng-container *ngIf="validity.get('validityRangeType')?.value == 'GENERIC'">
                      <div class="col-lg-4">
                        <label for="startDay" class="form-label">Giorno/Mese Inizio</label>
                        <div class="d-flex align-items-center">
                          <input type="number" class="form-control" min="1" max="31" id="startDay" placeholder="GG"
                            formControlName="startDay" style="width: 100px;">/
                          <input type="number" class="form-control" min="1" max="12" id="startMonth" placeholder="MM"
                            formControlName="startMonth" style="width: 100px;">
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <label for="endDay" class="form-label">Giorno/Mese Fine</label>
                        <div class="d-flex align-items-center">
                          <input type="number" class="form-control" min="1" max="31" id="endDay" placeholder="GG"
                            formControlName="endDay" style="width: 100px;">/
                          <input type="number" class="form-control" min="1" max="12" id="endMonth" placeholder="MM"
                            formControlName="endMonth" style="width: 100px;">
                        </div>

                      </div>
                    </ng-container>

                  </div>
                  <div class="card mt-3">
                    <div class="card-header">
                      <div class="d-flex gap-2">
                        <span> Fascie orarie </span>
                        <div class="cursor-pointer" (click)="addTimeRange(i)"
                          *hasPermission="['PARKING_AREA_UPDATE','PARKING_AREA_ALL']">
                          <i bTooltip title="Elimina" class="fa-solid fa-plus"></i>
                        </div>
                      </div>

                    </div>
                    <div class="card-body" formArrayName="timeRange">
                      <div *ngFor="let time of getTimeRange(i).controls; let j = index" [formGroupName]="j"
                        class="row align-items-start mb-2">
                        <div class="col-md-1 d-flex align-items-center justify-content-center">
                          <div class="cursor-pointer" (click)="removeTimeRange(i, j)"
                            *hasPermission="['PARKING_AREA_UPDATE','PARKING_AREA_ALL']">
                            <i bTooltip title="Elimina" class="fa-solid fa-trash"></i>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">Ora Inizio</label>
                          <input type="time" class="form-control" formControlName="startTime">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">Ora Fine</label>
                          <input type="time" class="form-control" formControlName="endTime">
                        </div>
                        <div class="col-md-2">
                          <label class="form-label">Tariffa giornaliera</label>
                          <input type="number" class="form-control" formControlName="rate">
                        </div>
                        <div class="row align-items-start">
                          <div class="col-md-1 d-flex align-items-center justify-content-center"></div>
                          <div class="col-md-2">
                            <label class="form-label">Tariffa oraria</label>
                            <input type="number" class="form-control" formControlName="rateHH">
                          </div>
                          <div class="col-md-2">
                            <label class="form-label">Max. ore di sosta</label>
                            <input type="number" class="form-control" formControlName="limitHH">
                          </div>

                          <div class="col-md-3">
                            <label class="form-label">Seleziona giorni settimana</label>
                            <select class="form-select" multiple aria-label="multiple select example"
                              formControlName="daysArray" style="height: 161px;overflow: hidden;">
                              <option value="0">Lunedi</option>
                              <option value="1">Martedi</option>
                              <option value="2">Mercoledi</option>
                              <option value="3">Giovedi</option>
                              <option value="4">Venerdi</option>
                              <option value="5">Sabato</option>
                              <option value="6">Domenica</option>
                            </select>
                          </div>
                        </div>
                        <hr>
                      </div>
                    </div>
                  </div>
                  <hr>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="d-flex justify-content-end align-items-center mt-2 gap-2">
            <button class="btn btn-outline-secondary" (click)="goBack()">Indietro</button>
            <ng-template [hasPermission]="['PARKING_AREA_DELETE', 'PARKING_AREA_ALL']">
              @if (parkingArea.id !== undefined) {
              <button type="button" (click)="confirmDelete()" class="btn btn-danger">
                Elimina
              </button>
              }
            </ng-template>
            <ng-template [hasPermission]="['PARKING_AREA_UPDATE', 'PARKING_AREA_ALL']">
              @if (parkingArea.id !== undefined) {

              <button type="submit" class="btn btn-primary">
                Salva
              </button>
              }
            </ng-template>
            <ng-template [hasPermission]="['PARKING_AREA_CREATE', 'PARKING_AREA_ALL']">
              @if (parkingArea.id === undefined) {
              <button type="submit" class="btn btn-primary">
                Salva
              </button>
              }

            </ng-template>

          </div>
        </div>
      </div>
    </form>
  </div>

  <app-confirm-alert [confirmationMessage]="'Eliminazione template - '+confirmationMessage"
    [showConfirmationModal]="showConfirmationModal" (modalConfirm)="delete()" (modalCancel)="cancelDelete()">
  </app-confirm-alert>
</ng-container>